import React, { useContext } from 'react';
import { IndexContext } from '../../context';

const FAQ = () => {
  const { baseUrl } = useContext(IndexContext);

  return (
    <section className="index-faq">
      <div id="index-faq" />
      <h2 className="index-heading-blue index-faq-heading">FAQ</h2>
      <div className="faq-content">
        <a
          className="index-faq-link"
          href={`${baseUrl}/documentation/#/holdshort-com-pilot-users-guide-v-2-5`}
          target="_blank"
        >
          <span>Pilot user guide</span>
          <svg width="13px" height="19px" className="svg-sprite more-link-icon">
            <use href={`${baseUrl}/public/images/shapes.svg?v=#arrow-top-thin`} />
          </svg>
        </a>
        <a
          className="index-faq-link"
          href={`${baseUrl}/documentation/#/holdshort-com-administrative-user-guide`}
          target="_blank"
        >
          <span>Administrator user guide</span>
          <svg width="13px" height="19px" className="svg-sprite more-link-icon">
            <use href={`${baseUrl}/public/images/shapes.svg?v=#arrow-top-thin`} />
          </svg>
        </a>
        <br/>
        <span className="index-faq-link"
              onClick={() => { window.Chatling && window.Chatling.open()} }
        >
          <span children='Ask a question'/>
            <svg width="13px" height="19px" className="svg-sprite more-link-icon">
              <use href={`${baseUrl}/public/images/shapes.svg?v=#arrow-top-thin`} />
            </svg>
        </span>
      </div>
    </section>
  );
};

export default FAQ;
